import { useEffect, useState } from 'react';
import { api, calcularEdad, Campo } from './Acceso';

// Case- and accent-insensitive, so "jeronimo" finds "JERÓNIMO".
const normalizar = (texto) => texto.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase();

const waLink = (telefono, mensaje) =>
  `https://wa.me/57${telefono}?text=${encodeURIComponent(mensaje)}`;

function IngresoAdmin({ alIngresar }) {
  const [correo, setCorreo] = useState('sensei@dojokamae.co');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [enviando, setEnviando] = useState(false);

  const ingresar = async (e) => {
    e.preventDefault();
    setError('');
    setEnviando(true);
    try {
      await api('/api/admin/ingresar', { correo, password });
      alIngresar();
    } catch (err) {
      setError(err.message);
      setEnviando(false);
    }
  };

  return (
    <form className="acceso__form" onSubmit={ingresar}>
      <h1 className="acceso__titulo">Panel del Sensei</h1>
      <Campo label="Correo" type="email" value={correo} onChange={(e) => setCorreo(e.target.value)} autoComplete="username" required />
      <Campo label="Contraseña" type="password" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" required />
      {error && <p className="acceso__error">{error}</p>}
      <button className="btn btn--primary acceso__btn" disabled={enviando}>
        Ingresar
      </button>
      <p className="acceso__alt">
        <a href="/recuperar?admin">¿Olvidaste tu contraseña?</a>
      </p>
    </form>
  );
}

function AgregarEstudiante({ alAgregar }) {
  const [datos, setDatos] = useState({ nombre: '', correo: '', telefono: '' });
  const [nuevo, setNuevo] = useState(null);
  const [error, setError] = useState('');

  const cambiar = (campo) => (e) => setDatos({ ...datos, [campo]: e.target.value });

  const agregar = async (e) => {
    e.preventDefault();
    setError('');
    try {
      setNuevo(await api('/api/admin/estudiantes', datos));
      setDatos({ nombre: '', correo: '', telefono: '' });
      alAgregar();
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <form className="acceso__seccion" onSubmit={agregar}>
      <h2>Agregar estudiante</h2>
      <Campo label="Nombre y apellido del atleta" value={datos.nombre} onChange={cambiar('nombre')} required />
      <div className="acceso__fila acceso__fila--parejo">
        <Campo label="Correo del acudiente" type="email" value={datos.correo} onChange={cambiar('correo')} />
        <Campo label="Teléfono" value={datos.telefono} onChange={cambiar('telefono')} inputMode="tel" />
      </div>
      {error && <p className="acceso__error">{error}</p>}
      {nuevo && (
        <p className="acceso__aviso">
          {nuevo.nombreAtleta}: código <code>{nuevo.codigo}</code>
        </p>
      )}
      <button className="btn btn--ghost acceso__btn">Agregar</button>
    </form>
  );
}

function FichaEstudiante({ e, recargar }) {
  const [abierta, setAbierta] = useState(false);
  const [enlace, setEnlace] = useState('');
  const [error, setError] = useState('');

  const accion = async (nombre, confirmacion) => {
    if (confirmacion && !window.confirm(confirmacion)) return;
    setError('');
    try {
      const res = await api(`/api/admin/estudiantes/${encodeURIComponent(e.codigo)}/${nombre}`, {});
      if (res.enlace) setEnlace(res.enlace);
      else recargar();
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <li className="admin__ficha">
      <button type="button" className="admin__cabecera" onClick={() => setAbierta(!abierta)} aria-expanded={abierta}>
        <span className="admin__nombre">{e.nombreAtleta}</span>
        <span className="admin__chips">
          <code>{e.codigo}</code>
          <span className={`admin__chip${e.registrado ? ' admin__chip--ok' : ''}`}>{e.registrado ? 'Registrado' : 'Pendiente'}</span>
          {e.tiene2fa && <span className="admin__chip">A2F</span>}
          {e.llaves > 0 && <span className="admin__chip">{e.llaves} llave{e.llaves > 1 ? 's' : ''}</span>}
          {e.bloqueado && <span className="admin__chip admin__chip--alerta">Bloqueado</span>}
        </span>
      </button>

      {abierta && (
        <div className="admin__detalle">
          <dl className="acceso__datos">
            {e.registrado && (
              <>
                <div><dt>Papá o mamá</dt><dd>{e.nombreAcudiente}</dd></div>
                <div><dt>Documento</dt><dd>{e.documento}</dd></div>
                <div><dt>Nacimiento</dt><dd>{e.fechaNacimiento} · {calcularEdad(e.fechaNacimiento)} años</dd></div>
                <div><dt>Dirección</dt><dd>{e.direccion}</dd></div>
              </>
            )}
            <div>
              <dt>Contacto</dt>
              {e.telefono || e.correo ? (
                <>
                  {e.telefono && <dd>{e.telefono}</dd>}
                  {e.correo && <dd>{e.correo}</dd>}
                </>
              ) : (
                <dd>Sin datos</dd>
              )}
            </div>
          </dl>

          <div className="admin__acciones">
            {!e.registrado && e.telefono && (
              <a
                className="btn btn--ghost acceso__btn"
                href={waLink(e.telefono, `Hola. Este es el código de ${e.nombreAtleta} para registrarse en ${window.location.origin}/registro : ${e.codigo}`)}
                target="_blank"
                rel="noreferrer"
              >
                Enviar código por WhatsApp
              </a>
            )}
            {e.registrado && (
              <button type="button" className="btn btn--ghost acceso__btn" onClick={() => accion('enlace')}>
                Enlace para cambiar contraseña
              </button>
            )}
            {(e.tiene2fa || e.llaves > 0) && (
              <button
                type="button"
                className="btn btn--ghost acceso__btn"
                onClick={() => accion('quitar-seguridad', `¿Quitar la verificación en dos pasos y las llaves de acceso de ${e.nombreAtleta}?`)}
              >
                Quitar A2F y llaves
              </button>
            )}
            {e.bloqueado && (
              <button type="button" className="btn btn--ghost acceso__btn" onClick={() => accion('desbloquear')}>
                Desbloquear
              </button>
            )}
          </div>

          {enlace && (
            <div className="acceso__aviso">
              <p>Enlace de un solo uso, válido por 24 horas:</p>
              <code>{enlace}</code>
              {e.telefono && (
                <a
                  href={waLink(e.telefono, `Hola. Con este enlace puedes crear una nueva contraseña para la cuenta de ${e.nombreAtleta}: ${enlace}`)}
                  target="_blank"
                  rel="noreferrer"
                >
                  Enviar por WhatsApp
                </a>
              )}
            </div>
          )}
          {error && <p className="acceso__error">{error}</p>}
        </div>
      )}
    </li>
  );
}

export default function Admin() {
  const [estudiantes, setEstudiantes] = useState(null);
  const [sinSesion, setSinSesion] = useState(false);
  const [busqueda, setBusqueda] = useState('');

  const cargar = () =>
    api('/api/admin/estudiantes')
      .then((lista) => {
        setEstudiantes(lista);
        setSinSesion(false);
      })
      .catch(() => setSinSesion(true));

  useEffect(() => {
    cargar();
  }, []);

  const salir = async () => {
    await api('/api/admin/salir', {});
    setEstudiantes(null);
    setSinSesion(true);
  };

  if (sinSesion) return <IngresoAdmin alIngresar={cargar} />;
  if (!estudiantes) return <p className="acceso__lead">Cargando…</p>;

  const filtro = normalizar(busqueda.trim());
  const visibles = estudiantes.filter((e) => !filtro || normalizar(e.nombreAtleta).includes(filtro) || e.codigo.includes(filtro));
  const registrados = estudiantes.filter((e) => e.registrado).length;

  return (
    <div className="acceso__form">
      <h1 className="acceso__titulo">Panel del Sensei</h1>
      <p className="acceso__lead">
        {registrados} de {estudiantes.length} estudiantes registrados.
      </p>
      <Campo label="Buscar por nombre o código" value={busqueda} onChange={(e) => setBusqueda(e.target.value)} type="search" />
      <ul className="admin__lista">
        {visibles.map((e) => (
          <FichaEstudiante key={e.codigo} e={e} recargar={cargar} />
        ))}
      </ul>
      <AgregarEstudiante alAgregar={cargar} />
      <button className="btn btn--ghost acceso__btn" onClick={salir}>
        Cerrar sesión
      </button>
    </div>
  );
}
